export const DtiTablePropsBase = {
  titleText: ' with Achieve Resolution',
  firstColumnLabel: 'Est. monthly payment',
  lastColumnLabel: 'Est. total debt cost',
  labelFirstRow: 'On your own',
  monthlyCurrent: '$726',
  monthlyAchieve: '$470',
  monthlySavings: '$256',
  totalCurrent: '$41,023',
  totalAchieve: '$22,543',
}
